import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { values } from "@/mocks/site";

export default function ValueGrid() {
  return (
    <section className="w-full bg-background-100 px-4 py-16 md:px-6 md:py-24">
      <div className="mx-auto w-full">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="平台价值"
            title="投稿之前，先把三件事弄明白"
            desc="投什么、怎么写、编辑在看什么。把这三个问题理清，你的稿件就从「随手一发」变成了「有的放矢」。"
          />
          <p className="max-w-sm text-sm leading-relaxed text-foreground-500 md:text-right">
            我们不做匿名爆料墙，只做一套把投稿这件事讲清楚的参考体系，让普通人也能写出被采用的线索。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {values.map((item, index) => (
            <Reveal key={item.title} delay={index * 90}>
              <article className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
                <div className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                  <i className={`${item.icon} text-2xl leading-none`}></i>
                </div>
                <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">{item.title}</h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                <span className="mt-5 inline-flex w-fit items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-[11px] font-medium text-secondary-800">
                  <i className="ri-price-tag-3-line text-sm leading-none"></i>
                  {item.tag}
                </span>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={360}>
          <div className="mt-6 flex flex-col gap-5 rounded-lg bg-secondary-900 p-6 text-background-50 md:flex-row md:items-center md:justify-between md:p-8">
            <div className="max-w-2xl">
              <p className="text-xs font-medium tracking-[0.2em] uppercase text-accent-400">新手友好</p>
              <h3 className="mt-3 font-heading text-xl font-bold leading-snug md:text-2xl">
                第一次投稿，从一份三百字的概述开始
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-background-100/75">
                不用会写文章，也不用懂结构。把你经历的事按时间顺序讲清楚，剩下的交给编辑。
              </p>
            </div>
            <a
              href="#faq"
              className="inline-flex w-fit items-center gap-2 rounded-md bg-accent-500 px-5 py-3 text-sm font-medium text-accent-950 transition-colors hover:bg-accent-400 whitespace-nowrap cursor-pointer"
            >
              看看常见问题
              <i className="ri-arrow-right-line text-base leading-none"></i>
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}